import image1 from "./imgs/newscard1.webp";
import image2 from "./imgs/newscard2.webp";
import image3 from "./imgs/newscard3.webp";

const images = [image1, image2, image3];

export default images;
